// eslint-disable-next-line import/no-named-as-default
import React from "react";

import { FilterKey } from "./context/FilterButtonContext";
import { ContributingWellsFromAllFacilitiesButton } from "./filters/ContributingWellsFromAllFacilitiesButton";
import { FacilityAndWellsButton } from "./filters/FacilityAndWellsButton";
import { HighlightWellsButton } from "./filters/HighlightWellsFilterButton";
import { SalesFacilitiesButton } from "./filters/SalesFacilitiesFilterButton";
import { WellNetworkButton } from "./filters/WellNetworkFilterButton";

interface FilterButtonProps {
  filterKey: FilterKey;
}

// Factory function to create filter-specific components
const createFilterButton = (filterKey: FilterKey): React.FC => {
  switch (filterKey) {
    case FilterKey.HighlightWells:
      return HighlightWellsButton;
    case FilterKey.FacilityAndWells:
      return FacilityAndWellsButton;
    case FilterKey.ContributingWellsFromAllFacilities:
      return ContributingWellsFromAllFacilitiesButton;
    case FilterKey.WellNetwork:
      return WellNetworkButton;
    case FilterKey.SalesFacilities:
      return SalesFacilitiesButton;
    default:
      return () => null;
  }
};

const FilterButton: React.FC<FilterButtonProps> = ({ filterKey }) => {
  const FilterComponent = createFilterButton(filterKey);

  return <FilterComponent />;
};

export default FilterButton;
